import { Trans, useTranslation } from "react-i18next";
import { css } from "../../../../styled-system/css";
import { Button } from "../../../components/core/basic/Button";
import DismissibleBanner from "../../../components/core/basic/DismissibleBanner";
import { useWalmartMarketplaceStatus } from "./useWalmartMarketplaceStatus";
import { useAppSelector } from "../../../redux/hooks";
import { useNavigate } from "@tanstack/react-router";

export const WalmartReauthBanner = () => {
  const orgId = useAppSelector((state) => state.user.organization_id);
  const { data: status } = useWalmartMarketplaceStatus();
  const navigate = useNavigate();
  const { t } = useTranslation(["onboarding"]);

  const needsReauth = status?.auth_method === "oauth" && status.is_connected === false;

  if (!needsReauth) {
    return null;
  }

  return (
    <DismissibleBanner storageKey={`dismiss_walmart_reauth_banner_${orgId}`} dismissForDays={1}>
      <span className={css({ paddingX: 2, color: "white" })}>
        <Trans
          t={t}
          i18nKey={($) =>
            $.onboarding[
              "Your Walmart Marketplace connection has expired. <reauthorizeLink>Reauthorize</reauthorizeLink> to continue syncing data."
            ]
          }
          components={{
            reauthorizeLink: (
              <Button
                variant="link"
                css={{ display: "inline" }}
                onPress={() => void navigate({ to: "/user/walmartsummary" })}
              >
                {""}
              </Button>
            ),
          }}
        />
      </span>
    </DismissibleBanner>
  );
};
